<template>
  <a target="_blank" v-if="href" class="link" :href="href">
    <slot />
  </a>
  <button v-else :class="['btn', variant]" :disabled="disabled" @click="(ev) => $emit('click', ev)">
    <span class="altru-button__content">
      <slot />
    </span>
  </button>
</template>

<script lang="ts">
import { PropType } from 'vue';

export default {
  name: 'Button',
  props: {
    href: String,
    disabled: Boolean,
    variant: {
      type: String as PropType<'primary' | 'secondary' | 'link'>,
    },
  },
};
</script>
